import * as React from "react";
import { cn } from "@/lib/utils";

export function Tooltip({ content, children }: { content: React.ReactNode; children: React.ReactNode }) {
  const [open, setOpen] = React.useState(false);
  return (
    <span className="relative inline-block" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <span onFocus={() => setOpen(true)} onBlur={() => setOpen(false)}>{children}</span>
      {open && (
        <span
          role="tooltip"
          className={cn(
            "pointer-events-none absolute -top-2 left-1/2 -translate-x-1/2 -translate-y-full whitespace-nowrap rounded-md border border-border bg-popover px-2 py-1 text-xs text-popover-foreground shadow"
          )}
        >
          {content}
        </span>
      )}
    </span>
  );
}
